import clsx from "clsx";

import type { IncidentKind } from "../api/types";

const KIND: Record<IncidentKind, string> = {
  TAC: "bg-incident-tac text-white",
  TEC: "bg-incident-tec text-white",
  ENV: "bg-incident-env text-incident-env-ink",
};

/** Code d'un incident de la DIREX (« TAC 3 », « ENV 12 ») : pastille de 20 px aux couleurs de l'iPad — tactique
 *  rouge, technique gris, environnement jaune à texte foncé — en chiffres tabulaires. */
export function IncidentCode({
  kind,
  code,
  title,
  className,
}: {
  kind: IncidentKind;
  code: string;
  title?: string;
  /** Marges seulement. */
  className?: string;
}) {
  return (
    <span
      title={title}
      className={clsx(
        "inline-flex h-5 shrink-0 items-center rounded-md px-1.5 text-meta leading-none font-semibold whitespace-nowrap tabular-nums",
        KIND[kind],
        className,
      )}
    >
      {code}
    </span>
  );
}
